<div class="global-material-root" [ngClass]="activeRoute">
  <div id="sidebar">
    <div class="container-navbar-loader" *ngIf="!isLoaded">
      <app-loader></app-loader>
    </div>
    <div class="container-navbar" *ngIf="isLoaded">
        <app-material-timeline></app-material-timeline>
    </div>
  </div>

  <div class="main-content-materials-loader" *ngIf="!isLoaded">
    <app-loader></app-loader>
  </div>
  <div class="main-content-materials"  id="main-content-materials" *ngIf="isLoaded">
    <router-outlet></router-outlet>
  </div>
</div>



